export default {
  namespaced: true,
  state: {
    hasReadErrorPage: false,
    dontCache: [], // 在这里定义你不想要缓存的页面的name属性值
    formData: {},
    dInvoiceCount: 0,
    applyInvoice: true,
    invoiceType: '',
    invoiceStatus: false,
    // 订单id
    billId: '',
    // 当前发票Id
    invoiceId: '',
    // 电票预览数据
    elepreveData: [],
    // 点票再次推送数据
    eleSendagainData: [],
    invoiceAccount: 1000,
    // 获取开局发票头
    OpenCardTitle: {
      // 商品名称
      sellerName: '新疆自治区哈密三道岭百望企服有限公司',
      // 订单金额
      invoiceTotalPrice: '124.02',
      // 备注
      remark: '“111运输服务”客运服务费、餐饮费、住宿费、信运输服务客运服务费、餐饮费、住宿费、信'
    },
    //  销方税号
    sellerTaxNo: '',
    // 开具对象
    InvoiceData: {},
    // 开具地址
    InvoiceAdd: {},
    refundNum: -1

  },
  getters: {},
  mutations: {
    setHasReadErrorLoggerStatus (state, status = true) {
      state.hasReadErrorPage = status
    },
    // 设置发票展示页的数据
    setFormData (state, obj) {
      state.formData = obj
    },
    setdInvoiceCount (state, obj) {
      state.dInvoiceCount = obj
    },
    setApplyInvoice (state, obj) {
      state.applyInvoice = obj
    },
    setInvoiceType (state, obj) {
      state.invoiceType = obj
    },
    setBillId (state, obj) {
      state.billId = obj
    },
    setInvoiceStatus (state, obj) {
      state.invoiceStatus = obj
    },
    setInvoiceId (state, obj) {
      state.invoiceId = obj
    },
    setelepreveData (state, obj) {
      state.elepreveData = obj
    },
    seteleSendagainData (state, obj) {
      state.eleSendagainData = obj
    },
    setSellerTaxNo (state, obj) {
      state.sellerTaxNo = obj
    },
    setInvoiceAccount (state, obj) {
      state.invoiceAccount = obj
    },
    setOpenCardTitle (state, obj) {
      obj.forEach((item, index) => {
        state.OpenCardTitle[item.name] = item.val
      })
    },
    setInvoiceData (state, obj) {
      state.InvoiceData = obj
    },
    setInvoiceAdd (state, obj) {
      state.InvoiceAdd = obj
    },
    setrefundNum (state, obj) {
      state.refundNum = obj
    }

  },
  actions: {
    addErrorLog ({ commit }, info) {
      if (!window.location.href.includes('error_logger_page')) {
        commit('setHasReadErrorLoggerStatus', false)
      }
      // 此处想做一个显示错误信息的处理
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js